<template>
  <base-section
    id="workshops"
    :space="0"
  >
    <v-container>
      <div>
        <v-tabs
          id="tab-workshops"
        >
          <v-tab
            class="font-weight-bold"
            min-width="96"
            text
            :href="`#tab-workshops-home`"
            @click="goToTop"
          >
            Fringe Workshops
          </v-tab>
          <v-tab
            class="font-weight-bold"
            min-width="96"
            text
            :href="`#tab-workshops-ai-treats`"
            @click="goToTop"
            id="ai-treats"
          >
            AI-Treats
          </v-tab>
          <v-tab
            class="font-weight-bold"
            min-width="96"
            text
            :href="`#tab-workshops-e-arts`"
            @click="goToTop"
            id="e-arts"
          >
            eARTS
          </v-tab>
          <v-tab
            class="font-weight-bold"
            min-width="96"
            text
            :href="`#tab-workshops-imtr`"
            @click="goToTop"
            id="imtr"
          >
            IMTR
          </v-tab>
          <v-tab-item
            :value="`tab-workshops-home`"
          >
            <fringe-workshops />
          </v-tab-item>
          <v-tab-item
            :value="`tab-workshops-ai-treats`"
          >
            <ai-treats />
          </v-tab-item>
          <v-tab-item
            :value="`tab-workshops-e-arts`"
          >
            <e-arts />
          </v-tab-item>
          <v-tab-item
            :value="`tab-workshops-imtr`"
          >
            <imtr />
          </v-tab-item>
        </v-tabs>
      </div>
    </v-container>
  </base-section>
</template>
<script>
  import SubmitWorkshops from './SubmitWorkshops.vue'
  import FringeWorkshops from './FringeWorkshops.vue'
  import AiTreats from './AiTreats.vue'
  import EArts from './EArts.vue'
  import Imtr from './Imtr.vue'
  export default {
    name: 'Workshops',
    components: { FringeWorkshops, SubmitWorkshops, AiTreats, EArts, Imtr },

    data: () => ({
      tab: null,
      items: [
        'Fringe Workshops',
        'Submit a proposal',
      ],
    }),
    mounted () {
      var section = this.$router.currentRoute.hash.replace('#', '')
      var mobile = this.isMobileDevice()
      console.log(section)
      if (section && !mobile) {
        document.getElementById(section).click()
      } else if (section === '' && mobile) {
        this.$router.push('fringe-workshops')
      } else if (section && mobile) {
        this.$router.push(section)
      }
      document.getElementById('tab-workshops').firstChild.style = 'position: fixed; background-color: #fafafa !important; width = 100%; margin-top: -11px; z-index: 5; width: 100%'
    },
    methods: {
      goToTop () {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        })
      },
      isMobileDevice () {
        return (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
      },
    },
  }
</script>
